/**
 * A simple task queue with a fixed time between tasks.
 *
 * This is to ensure that user interactions are processed in order and with
 * enough time inbetween interactions for animations and other logic.
 *
 * In its current form this uses a fixed delay that must be provided to the
 * constructor. It would be easy to convert the queue to wait for promises
 * returned by the tasks to be resolved.
 */
export default class CarouselQueue {
  isRunning = false
  tasks = []

  /**
   * Constructs an empty queue and sets the delay between tasks.
   * @param {Number} delay The delay between tasks.
   */
  constructor(delay) {
    this.delay = delay
  }

  /**
   * Adds a new task to the queue.
   * @param {Function} task The function to call.
   */
  add(task) {
    this.tasks.push(task)
    this.next()
  }

  /**
   * Runs the next task unless the queue is empty or another task is already
   * running. If a task is run the method calls itself after the set delay.
   */
  next() {
    if (this.tasks.length > 0 && !this.isRunning) {
      this.isRunning = true
      let task = this.tasks.shift()

      task()

      this.timeout = setTimeout(() => {
        this.isRunning = false
        this.next()
      }, this.delay)
    }
  }

  /**
   * Empties the task queue.
   */
  clear() {
    this.tasks = []
  }

  /**
   * Clean-up method that should be used when unloading the carousel.
   */
  destroy() {
    clearTimeout(this.timeout)
    this.clear()
  }
}
